import ApiClient from '../api/apiClient';

const RENEWALCERTIFICATES = "/certificates/renewal";
const RENEWALAPPLICANTDETAIL = "/certificates/renewal"
const UPDATERENEWALSTATUS = "/certificates/renewal/status"
const RENEWALSTATUSCOUNT = "/certificates/get-renewal-status-count"
const getRenewalCertificates = ({
  page,
  limit,
  search,
  renewal_status,
  certificate_type,
  full_name,
  registered_from,
  registered_to,
  start_date,
  end_date,
  field_of_technology,
  identity_number,
}) => {
  const baseUrl = `${RENEWALCERTIFICATES}?`;

  let queryParams = "";

  // Add mandatory parameters
  queryParams += `page=${page}&limit=${limit}&certificate_type=${certificate_type}`;

  // Add optional parameters if present

  if (registered_from) queryParams += `&registered_from=${registered_from}`;
  if (registered_to) queryParams += `&registered_to=${registered_to}`;
  if (identity_number) queryParams += `&identity_number=${identity_number}`;
  if (search) queryParams += `&search=${search}`;
  if (field_of_technology) queryParams += `&field_of_technology=${field_of_technology}`;
  if (full_name) queryParams += `&full_name=${full_name}`;
  if (renewal_status) queryParams += `&renewal_status=${renewal_status}`;
  if (start_date) queryParams += `&start_date=${start_date}`;
  if (end_date) queryParams += `&end_date=${end_date}`;

  const url = baseUrl + queryParams;

  return ApiClient.get(url);
};

const getRenewalApplicantDetails = (id) => {
  const url = RENEWALAPPLICANTDETAIL + "/" + id;
  return ApiClient.get(url);
}

const updateRenewalApplicantDetails = (data) => {
  return ApiClient.put(UPDATERENEWALSTATUS, data);
}

const getRenewalStatusCount = ({ search,
  renewal_status,
  certificate_type,
  full_name,
  registered_from,
  registered_to,
  start_date,
  end_date,
  field_of_technology,
  identity_number, }) => {
  const baseUrl = `${RENEWALSTATUSCOUNT}?`;

  let queryParams = "";

  // Add optional parameters if present
if (certificate_type) queryParams += `&certificate_type=${certificate_type}`
  if (registered_from) queryParams += `&registered_from=${registered_from}`;
  if (registered_to) queryParams += `&registered_to=${registered_to}`;
  if (identity_number) queryParams += `&identity_number=${identity_number}`;
  if (search) queryParams += `&search=${search}`;
  if (field_of_technology) queryParams += `&field_of_technology=${field_of_technology}`;
  if (full_name) queryParams += `&full_name=${full_name}`;
  if (renewal_status) queryParams += `&renewal_status=${renewal_status}`;
  if (start_date) queryParams += `&start_date=${start_date}`;
  if (end_date) queryParams += `&end_date=${end_date}`;

  const url = baseUrl + queryParams;

  return ApiClient.get(url);
}
export const renewalService = {
  getRenewalCertificates,
  getRenewalApplicantDetails,
  updateRenewalApplicantDetails,
  getRenewalStatusCount,
};